export default "__VITE_ASSET__8402118c__"